import { render, staticRenderFns } from "./Lpa.vue?vue&type=template&id=402c2331"
import script from "./Lpa.vue?vue&type=script&lang=js"
export * from "./Lpa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports